import React from "react";

import OTPForm from "@components/OTPForm";

import {
  useCandidateLoginSharedData,
  useCandidateLoginStepper,
} from "../../context";

import { OTP_SCOPES } from "@utils/enum";

const CandidateLoginOtpStep = () => {
  const { sharedData } = useCandidateLoginSharedData();
  const { onPrevStep } = useCandidateLoginStepper();

  return (
    <OTPForm
      id={sharedData?.candidateId}
      scope={OTP_SCOPES.LOGIN_CANDIDATE}
      onSubmit={sharedData?.onSuccess}
      onCancel={onPrevStep}
      onError={sharedData?.onError}
    />
  );
};

export default CandidateLoginOtpStep;
